import React, { FC, forwardRef } from 'react';
import cx from 'classnames';
import { setDash } from '../../../lib/common';
import { Input } from 'antd';
import { TextAreaRef, TextAreaProps } from 'antd/es/input/TextArea';
import './TextArea.scss';

const { TextArea } = Input;

export interface CustomTextAreaProps extends Omit<TextAreaProps, 'onChange'> {
  isEditable?: boolean;
  onChange?: (value: string) => void;
}

const CustomTextArea: FC<CustomTextAreaProps> = forwardRef<TextAreaRef, CustomTextAreaProps>((props, ref) => {
  const {
    className,
    value,
    isEditable = true,
    onChange,
    maxLength,
    autoSize = { minRows: 2, maxRows: 6 },
    ...res
  } = props;

  return (
    <>
      {isEditable ? (
        <TextArea
          className={cx('amondz-textArea', className)}
          autoSize={autoSize}
          onChange={(e) =>
            (!maxLength || (maxLength && e.target.value.length <= maxLength)) && onChange && onChange(e.target.value)
          }
          value={value}
          ref={ref}
          {...res}
        />
      ) : (
        <div className="amondz-textArea read-only">{setDash(value)}</div>
      )}
    </>
  );
});

CustomTextArea.displayName = 'CustomTextArea';

export default CustomTextArea;
